<!-- Loading State -->
<div *ngIf="isLoading" class="loading-container">
  <div class="loading-content">
    <div class="loading-spinner"></div>
    <p class="loading-text">Validating access...</p>
  </div>
</div>

<!-- Main Builder Interface -->
<div *ngIf="!isLoading && hasValidGuid" class="app-layout" [class.chat-minimized]="isChatMinimized">
  <div class="preview-panel">
    <app-website-preview
      #websitePreview
      (openInlineEditor)="openInlineEditor($event)"
      (imageUploaderRequested)="handleImageUploader($event)"
    ></app-website-preview>
  </div>
  <div class="chat-panel" [class.minimized]="isChatMinimized">
    <!-- Chat Component - Only visible when state is CHAT -->
    <app-otto-chat *ngIf="currentComponentState === ComponentState.CHAT"></app-otto-chat>
    
    <!-- Content Editor - Only visible when state is CONTENT_EDITOR -->
    <app-inline-content-editor
      *ngIf="currentComponentState === ComponentState.CONTENT_EDITOR"
      [editRequest]="currentEditRequest"
      [currentSupplierData]="currentSupplierData"
      [currentSemanticContent]="currentSemanticContent"
      (contentUpdated)="onContentUpdated($event)"
      (editCancelled)="onEditCancelled()"
      (keepOldContent)="onKeepOldContent()"
    ></app-inline-content-editor>
    
    <!-- Image Uploader - Only visible when state is IMAGE_UPLOADER -->
    <app-inline-image-uploader
      *ngIf="currentComponentState === ComponentState.IMAGE_UPLOADER"
      [uploadRequest]="currentImageUploadRequest"
      [currentSupplierData]="currentSupplierData"
      [currentSemanticContent]="currentSemanticContent"
      (imageUpdated)="onImageUpdated($event)"
      (uploadCancelled)="onImageUploadCancelled()"
    ></app-inline-image-uploader>
  </div>
  
  <!-- Guided Tour Overlay -->
  <app-tour-overlay></app-tour-overlay>
</div> 